import React, { JSX, Suspense } from 'react';
import { generatePath, Route } from 'react-router-dom';
import { QueryLoadingAbsolute } from '@ankr.com/raas-ui';
import { lazily, tCommon } from '@ankr.com/raas-utils';
import { createRouteConfig } from '@ankr.com/utils/createRouteConfig';

import { AuthGuard } from '../guards';
import { LayoutDefault } from '../layout/components/LayoutDefault';

const { Settings } = lazily(() => import('./screens/Settings'));

const PATH = '/settings';

export const SettingsRoutesConfig = createRouteConfig(
  {
    Settings: {
      path: PATH,
      generatePath: () => generatePath(PATH),
    },
  },
  PATH,
);

export function getSettingsRoutes(): JSX.Element {
  return (
    <Route
      path={SettingsRoutesConfig.root}
      element={
        <LayoutDefault title={tCommon('page-title.settings')}>
          <AuthGuard>
            <Suspense fallback={<QueryLoadingAbsolute />}>
              <Settings />
            </Suspense>
          </AuthGuard>
        </LayoutDefault>
      }
    />
  );
}
